import { motion } from "framer-motion";
import { useMobilI18n } from "@/lib/mobilI18n";

export default function MobilProcess() {
  const { m } = useMobilI18n();
  return (
    <section id="proces" data-testid="mobil-process" className="py-24 md:py-32 px-6 md:px-12 lg:px-24 bg-[#fdfcf9]">
      <div className="max-w-7xl mx-auto">
        <div className="max-w-2xl">
          <p className="uppercase tracking-[0.28em] text-xs text-[#3e664c] mb-4 font-medium">{m.process.eyebrow}</p>
          <h2 className="font-display text-4xl md:text-5xl tracking-[-0.02em] leading-[1.05]">{m.process.title}</h2>
          <p className="mt-5 text-[#5C544F] leading-relaxed">{m.process.desc}</p>
        </div>
        <ol className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 relative">
          <span className="hidden lg:block absolute top-6 left-6 right-6 h-px bg-gradient-to-r from-[#3e664c]/40 via-[#C9A24B]/50 to-[#3e664c]/10" />
          {m.process.steps.map((s, i) => (
            <motion.li
              key={s.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.12 }}
              data-testid={`mobil-step-${i}`}
              className="relative"
            >
              <span className="relative z-[1] w-12 h-12 rounded-full bg-[#3e664c] text-[#E2C9A0] font-display text-xl flex items-center justify-center shadow-[0_10px_25px_rgb(31,58,48,0.25)]">
                {i + 1}
              </span>
              <h3 className="mt-6 font-display text-2xl text-[#1c2421]">{s.title}</h3>
              <p className="mt-2 text-sm text-[#5C544F] leading-relaxed">{s.desc}</p>
            </motion.li>
          ))}
        </ol>
      </div>
    </section>
  );
}
